import config from 'rlink-debug-utils/config';
import jsonify from 'rlink-debug-utils/jsonify';

export default function logClientChatter (strMsg, ...args) {
  if (config.LOG_CLIENT_CHATTER) {
    console.info(strMsg, ...(args.map(jsonify)));
  }
}




// WEBPACK FOOTER //
// ./lib/rlink-debug-utils/logClientChatter.js